import Badge from "ds/components/Badge";
import { BadgeProps } from "ds/components/Badge/types";

import styles from "./ValueBadge.module.css";

type ChangeHistoryCardValueBadgeProps = {
  text: string;
  variant: BadgeProps["variant"];
};

const ChangeHistoryCardValueBadge = ({ text, variant }: ChangeHistoryCardValueBadgeProps) => (
  <Badge variant={variant} type="weak" text={text} textEllipsis className={styles.valueBadge} />
);

export default ChangeHistoryCardValueBadge;
